import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { DateTime } from "luxon";
import tzData from "tzdata";

const luxonValidTimezones = [
  ...new Set(Object.keys(tzData.zones).filter((tz) => tz.includes("/") && DateTime.local().setZone(tz).isValid)),
].sort((a, b) => (a < b ? -1 : 1));

/**
 * @param {object} props
 * @param {string|undefined} props.value
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.helperText]
 * @param {string} props.title
 */
export const TimezoneSelect = ({ value, onChange, helperText, title }) => {
  const onChangeHandler = async (event) => {
    onChange(event.target.value);
  };

  return (
    <FormControl sx={{ width: "100%" }} margin="normal">
      <InputLabel id="timezone-label">{title}</InputLabel>
      <Select
        labelId="timezone-label"
        id="timezone"
        value={value}
        onChange={onChangeHandler}
        label={title}
        input={<OutlinedInput label={title} />}
      >
        {luxonValidTimezones.map((x) => (
          <MenuItem key={x} value={x}>
            {x.replace("_", " ")}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};
